module.exports = __webpack_public_path__ + "static/img/partner-logo-10.7fdad693.png";